import {required} from "vuelidate/lib/validators";  
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric"; 
const StrPlanDeger = {
  mixins: [Api, Sabit],
    data() {
      return { 
        StrPlanDegerData:{
            Id: "",
            Tabloid: 0,
            Tablodetayid: 0,
            Donemid: 0,
            BirimId: null,
            Sapmanedeni: "",
            Alinacakonlem: "",
            Ilgililik: "",
            Etkililik: "",
            Etkinlik: "",
            Surdurulebilirlik: "",
            Deleted: false,
          },

        FormDataType:{ 
          Sapmanedeni:{FieldName:"Sapmanedeni",Field:"input",FieldTitle:"Sapmanedeni",FieldType:"text"},
          Alinacakonlem:{FieldName:"Alinacakonlem",Field:"input",FieldTitle:"Alinacakonlem",FieldType:"text"},
          Ilgililik:{FieldName:"Ilgililik",Field:"input",FieldTitle:"Ilgililik",FieldType:"text"},
          Etkililik:{FieldName:"Etkililik",Field:"input",FieldTitle:"Etkililik",FieldType:"text"},
          Etkinlik:{FieldName:"Etkinlik",Field:"input",FieldTitle:"Etkinlik",FieldType:"text"},
          Surdurulebilirlik:{FieldName:"Surdurulebilirlik",Field:"input",FieldTitle:"Surdurulebilirlik",FieldType:"text"},
        }   
      }
    },
    validations:{ 
        FormData: {
          Tabloid: { required },
        
        } 
    },


   

}
export default StrPlanDeger